// This file is generated automatically by `scripts/build/fp.ts`. Please, don't change it.

import { subWeeks as fn } from "../subWeeks.js";
import { convertToFP } from "./_lib/convertToFP.js";

export const subWeeksWithOptions = convertToFP(fn, 3);

// Fallback for modularized imports:
export default subWeeksWithOptions;
